<template>
  <div class="phone-verification">
    <h2 class="auth-title">Verifique seu telefone</h2>
    <p class="auth-subtitle">
      Enviamos um código de 6 dígitos para o número cadastrado via WhatsApp.
      Insira o código abaixo para continuar.
    </p>

    <BaseAlert v-if="errorMessage" variant="danger" class="mb-3">
      {{ errorMessage }}
    </BaseAlert>

    <BaseAlert v-if="successMessage" variant="success" class="mb-3">
      {{ successMessage }}
    </BaseAlert>

    <form @submit.prevent="handleConfirm">
      <BaseInput
        class="mb-3"
        type="tel"
        size="xl"
        id="verificationCode"
        placeholder="Código de 6 dígitos"
        v-model="code"
        maxlength="6"
        autocomplete="one-time-code"
      />

      <BaseButton
        class="mb-3"
        type="submit"
        size="xl"
        block
        :disabled="code.length !== 6 || isConfirming"
      >
        <span class="mr-2">Confirmar</span>
        <BaseSpinner v-if="isConfirming" variant="light" size="sm" />
      </BaseButton>
    </form>

    <BaseButton
      variant="secondary"
      size="xl"
      block
      :disabled="cooldown > 0 || isResending"
      @click="handleResend"
    >
      <template v-if="cooldown > 0">
        Reenviar código em {{ cooldown }}s
      </template>
      <template v-else>
        <span class="mr-2">Reenviar código</span>
        <BaseSpinner v-if="isResending" variant="secondary" size="sm" />
      </template>
    </BaseButton>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "PhoneVerificationForm",
  data() {
    return {
      code: "",
      errorMessage: "",
      successMessage: "",
      isConfirming: false,
      isResending: false,
      cooldown: 0,
      cooldownTimer: null
    };
  },
  mounted() {
    this.startSendingCode();
  },
  beforeDestroy() {
    this.clearCooldownTimer();
  },
  methods: {
    ...mapActions("user", ["sendPhoneCode", "verifyPhoneCode"]),

    async startSendingCode() {
      try {
        const response = await this.sendPhoneCode();
        const retryAfter = response?.data?.retry_after;
        if (retryAfter) {
          this.startCooldown(retryAfter);
        } else {
          this.startCooldown(60);
        }
      } catch (err) {
        const retryAfter = err?.response?.data?.retry_after;
        if (retryAfter) {
          this.startCooldown(retryAfter);
        }
      }
    },

    async handleConfirm() {
      this.errorMessage = "";
      this.isConfirming = true;
      try {
        await this.verifyPhoneCode(this.code);
        this.$emit("verified");
      } catch (err) {
        this.errorMessage =
          err?.response?.data?.error ||
          "Não foi possível verificar o código. Tente novamente.";
      } finally {
        this.isConfirming = false;
      }
    },

    async handleResend() {
      this.errorMessage = "";
      this.successMessage = "";
      this.isResending = true;
      try {
        await this.sendPhoneCode();
        this.startCooldown(60);
        this.successMessage = "Novo código enviado com sucesso.";
      } catch (err) {
        const retryAfter = err?.response?.data?.retry_after;
        if (retryAfter) {
          this.startCooldown(retryAfter);
          this.errorMessage = err.response.data.error;
        } else {
          this.errorMessage =
            err?.response?.data?.error ||
            "Não foi possível reenviar o código. Tente novamente.";
        }
      } finally {
        this.isResending = false;
      }
    },

    startCooldown(seconds) {
      this.clearCooldownTimer();
      this.cooldown = seconds;
      this.cooldownTimer = setInterval(() => {
        this.cooldown -= 1;
        if (this.cooldown <= 0) {
          this.clearCooldownTimer();
        }
      }, 1000);
    },

    clearCooldownTimer() {
      if (this.cooldownTimer) {
        clearInterval(this.cooldownTimer);
        this.cooldownTimer = null;
      }
    }
  }
};
</script>
